// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voucher-tabs-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.tabs-header {
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 0.5rem;
  gap: 0.5rem;
}

.tabs-list {
  display: flex;
  flex: 1;
  gap: 0.25rem;
  overflow-x: auto;
}

.tab-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-bottom: none;
  border-radius: 0.25rem 0.25rem 0 0;
  cursor: pointer;
  gap: 0.5rem;
  min-width: 150px;
  max-width: 250px;
  transition: all 0.2s ease;
}
.tab-item:hover {
  background-color: #f8f9fa;
}
.tab-item.active {
  background-color: #fff;
  border-color: #0d6efd;
  border-bottom-color: #fff;
  z-index: 1;
  position: relative;
  margin-bottom: -1px;
}

.tab-title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.875rem;
}

.tab-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
  color: #6c757d;
  transition: all 0.2s ease;
}
.tab-close-btn:hover {
  background-color: #e9ecef;
  color: #dc3545;
}
.tab-close-btn i {
  font-size: 0.75rem;
}

.add-tab-btn-inline {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  border: 1px solid #dee2e6;
  background: #fff;
  border-radius: 0.25rem 0.25rem 0 0;
  cursor: pointer;
  padding: 0 0.5rem;
  color: #6c757d;
  transition: all 0.2s ease;
  margin-left: 0.25rem;
  border-bottom: none;
}
.add-tab-btn-inline:hover {
  background-color: #f8f9fa;
  color: #0d6efd;
  border-color: #dee2e6;
}
.add-tab-btn-inline i {
  font-size: 0.875rem;
}

.tab-edit-input {
  flex: 1;
  border: 1px solid #0d6efd;
  border-radius: 0.125rem;
  padding: 0.125rem 0.25rem;
  font-size: 0.875rem;
  outline: none;
  background: #fff;
  min-width: 80px;
  max-width: 200px;
}

.tabs-content {
  flex: 1;
  overflow: auto;
  padding: 1rem;
}

@media (max-width: 768px) {
  .tab-item {
    min-width: 120px;
    max-width: 180px;
    padding: 0.375rem 0.75rem;
  }
  .tab-title {
    font-size: 0.8125rem;
  }
}
/* RTL Support */
.rtl .add-tab-btn-inline {
  margin-left: 0;
  margin-right: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/voucher-tabs/voucher-tabs.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,eAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kCAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AACF;AACE;EACE,yBAAA;AACJ;AAEE;EACE,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,yBAAA;AADF;AAGE;EACE,yBAAA;EACA,cAAA;AADJ;AAIE;EACE,kBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;AAHF;AAKE;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;AAHJ;AAME;EACE,mBAAA;AAJJ;;AAQA;EACE,OAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,OAAA;EACA,cAAA;EACA,aAAA;AALF;;AASA;EACE;IACE,gBAAA;IACA,gBAAA;IACA,yBAAA;EANF;EASA;IACE,oBAAA;EAPF;AACF;AAUA,gBAAA;AACA;EACE,cAAA;EACA,qBAAA;AARF","sourcesContent":[".voucher-tabs-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.tabs-header {\n  display: flex;\n  align-items: center;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n  padding: 0.5rem;\n  gap: 0.5rem;\n}\n\n.tabs-list {\n  display: flex;\n  flex: 1;\n  gap: 0.25rem;\n  overflow-x: auto;\n}\n\n.tab-item {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-bottom: none;\n  border-radius: 0.25rem 0.25rem 0 0;\n  cursor: pointer;\n  gap: 0.5rem;\n  min-width: 150px;\n  max-width: 250px;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background-color: #f8f9fa;\n  }\n\n  &.active {\n    background-color: #fff;\n    border-color: #0d6efd;\n    border-bottom-color: #fff;\n    z-index: 1;\n    position: relative;\n    margin-bottom: -1px;\n  }\n}\n\n.tab-title {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.875rem;\n}\n\n.tab-close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border: none;\n  background: transparent;\n  border-radius: 50%;\n  cursor: pointer;\n  padding: 0;\n  color: #6c757d;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background-color: #e9ecef;\n    color: #dc3545;\n  }\n\n  i {\n    font-size: 0.75rem;\n  }\n}\n\n.add-tab-btn-inline {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  height: 32px;\n  border: 1px solid #dee2e6;\n  background: #fff;\n  border-radius: 0.25rem 0.25rem 0 0;\n  cursor: pointer;\n  padding: 0 0.5rem;\n  color: #6c757d;\n  transition: all 0.2s ease;\n  margin-left: 0.25rem;\n  border-bottom: none;\n\n  &:hover {\n    background-color: #f8f9fa;\n    color: #0d6efd;\n    border-color: #dee2e6;\n  }\n\n  i {\n    font-size: 0.875rem;\n  }\n}\n\n.tab-edit-input {\n  flex: 1;\n  border: 1px solid #0d6efd;\n  border-radius: 0.125rem;\n  padding: 0.125rem 0.25rem;\n  font-size: 0.875rem;\n  outline: none;\n  background: #fff;\n  min-width: 80px;\n  max-width: 200px;\n}\n\n.tabs-content {\n  flex: 1;\n  overflow: auto;\n  padding: 1rem;\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .tab-item {\n    min-width: 120px;\n    max-width: 180px;\n    padding: 0.375rem 0.75rem;\n  }\n\n  .tab-title {\n    font-size: 0.8125rem;\n  }\n}\n\n/* RTL Support */\n.rtl .add-tab-btn-inline {\n  margin-left: 0;\n  margin-right: 0.25rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
